import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import clsx from 'clsx';
const TextInput = React.forwardRef(({ className, ...props }, ref) => (_jsx("input", { ref: ref, className: clsx('placeholder:inter-base-regular placeholder-grey-40 focus:outline-none', className), ...props })));
export default TextInput;
//# sourceMappingURL=index.js.map